import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import Spinner from '../../../components/spinner/Spinner';
import { getUrlParams } from '../../../utils/shared/urlUtils';
import Legend from '../../legend/shared/Legend';
import { MEASURE } from '../../../constants/shared/MeasuresConstants';
import { MEASURE_LIST_TOP } from '../../../constants/reading/DemoModeConstants';
import StudentSummaryNavigation from './studentSummaryNavigation/StudentSummaryNavigation';
import './StudentSummary.scss';

const { TRC } = MEASURE;

const StudentSummary = ({
    location,
    student,
    licensingInfo,
    chosenDistrictUid,
    LinkWrapper,
    navTabs,
    lastLocation,
    selectedTabId,
    legendSections,
    selectStudent,
    fetchStudentEnrollmentInfo,
    clearStudentSummaryData,
}) => {
    useEffect(() => {
        const { studentId } = getUrlParams(location);

        if (studentId && studentId !== student.externalId) {
            selectStudent(studentId);
            fetchStudentEnrollmentInfo(studentId);
        }
        return () => {
            clearStudentSummaryData();
        };
    }, []);
    if (!student.externalId) {
        return <Spinner />;
    }

    return (
        <div className="mclass-details-container">
            <StudentSummaryNavigation
                chosenDistrictUid={chosenDistrictUid}
                studentSummaryNavTabs={navTabs}
                selectedTabId={selectedTabId}
                lastLocation={lastLocation}
                LinkWrapper={LinkWrapper}
            />
            <div
                className="results-area"
                data-tour-step={MEASURE_LIST_TOP}
                data-tour-step-allow-interaction={false}
            >
                <div className={`content-info ${selectedTabId}`}>
                    <h2>{`${student.firstName} ${student.lastName}`}</h2>
                    <Legend
                        customClassName={`student-summary-legend ${
                            licensingInfo.includes(TRC) ? selectedTabId : ''
                        }`}
                        customButtonClassName="help-button"
                        sections={legendSections}
                        switchProp={selectedTabId}
                    />
                </div>
                <div className="ss-content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

StudentSummary.defaultProps = {
    licensingInfo: [],
    chosenDistrictUid: null,
    student: {},
    location: {},
    lastLocation: {},
    navTabs: [],
    selectedTabId: '',
    legendSections: [],
    selectStudent: () => {},
    fetchStudentEnrollmentInfo: () => {},
    clearStudentSummaryData: () => {},
    LinkWrapper: () => {},
};

StudentSummary.propTypes = {
    licensingInfo: PropTypes.array,
    chosenDistrictUid: PropTypes.string,
    student: PropTypes.object,
    location: PropTypes.object,
    lastLocation: PropTypes.object,
    navTabs: PropTypes.array,
    selectedTabId: PropTypes.string,
    legendSections: PropTypes.array,
    selectStudent: PropTypes.func,
    fetchStudentEnrollmentInfo: PropTypes.func,
    clearStudentSummaryData: PropTypes.func,
    LinkWrapper: PropTypes.func,
};

export default StudentSummary;
